import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import "./App.scss";
import GlobalState from "./context/GlobalState";
import ErrorBoundary from "./ErrorBoundary";
import MainContext from "./context/main-context";
import Configuration from "./views/Pages/Configuration/Configuration";
import UserService from "./services/UserService";
import { createBrowserHistory } from "history";
import { InitGA, PageView } from "./services/Tracking";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

const history = createBrowserHistory();
InitGA();
history.listen((location, action) => {
  PageView(location.pathname, location.search);
  console.log("Analytics Page View: " + location.pathname + location.search);
  console.log("Analytics Action: " + action);
});

// Containers
const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/Pages/Login"));
const SiteDown = React.lazy(() => import("./views/Pages/Login/SiteDown"));
const Verify = React.lazy(() => import("./views/Pages/Verify"));
const Register = React.lazy(() => import("./views/Pages/Register"));
const Oops = React.lazy(() => import("./views/Pages/Error/Oops"));
const Page404 = React.lazy(() => import("./views/Pages/Page404"));
const Page500 = React.lazy(() => import("./views/Pages/Page500"));
const PasswordReset = React.lazy(() => import("./views/Pages/PasswordReset"));
const Unauthorized = React.lazy(() => import("./views/Pages/Unauthorized"));

// Hide Console For All Environments Besides DEV
const Environment = process.env.REACT_APP_ENVIRONMENT;
if (Environment !== "development") console.log = function () {};
if (Environment !== "development") window.alert = function () {};

class App extends Component {
  static contextType = MainContext;

  componentDidMount() {
    this.checkForSensitiveMode();
  }

  componentDidUpdate() {
    this.checkForSensitiveMode();
  }

  checkForSensitiveMode() {
    const userService = new UserService();
    const isSensitive =
      sessionStorage.getItem("sensitive") === "true" ? true : false;
    if (isSensitive) {
      // let $style = document.createElement("style");
      // $style.id = "sensitiveMode";
      // $style.innerHTML = `.sensitive { filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='2');
      // -webkit-filter: url(#blur-filter);
      // filter: url(#blur-filter);
      // -webkit-filter: blur(2px);
      // filter: blur(2px); }`;
      // document.head.appendChild($style);
      userService.setPrivacyMode(true);
    } else {
      // var el = document.getElementById("sensitiveMode");
      // if (el) {
      //   el.remove();
      // }
      userService.setPrivacyMode(false);
    }
  }

  render() {
    return (
      <ErrorBoundary>
        <Router history={history}>
          <GlobalState>
            <React.Suspense fallback={loading()}>
              <Switch>
                <Route
                  exact
                  path="/login"
                  name="Login Page"
                  render={(props) => <Login {...props} />}
                />
                <Route
                  exact
                  path="/sitedown"
                  name="Site Down"
                  render={(props) => <SiteDown {...props} />}
                />
                <Route
                  exact
                  path="/Oops"
                  name="Oops: Somthing went wrong"
                  render={(props) => <Oops {...props} />}
                />
                <Route
                  exact
                  path="/PasswordReset"
                  name="Password Reset"
                  render={(props) => <PasswordReset {...props} />}
                />
                <Route
                  path="/ResetPassword"
                  name="Reset Password"
                  render={(props) => <PasswordReset {...props} />}
                />
                <Route
                  exact
                  path="/verify"
                  name="Verify Page"
                  render={(props) => <Verify {...props} />}
                />
                <Route
                  exact
                  path="/register"
                  name="Register Page"
                  render={(props) => <Register {...props} />}
                />
                <Route
                  exact
                  path="/404"
                  name="Page 404"
                  render={(props) => <Page404 {...props} />}
                />
                <Route
                  exact
                  path="/500"
                  name="Page 500"
                  render={(props) => <Page500 {...props} />}
                />
                <Route
                  exact
                  path="/Unauthorized"
                  name="Unauthorized"
                  render={(props) => <Unauthorized {...props} />}
                />
                <Route
                  exact
                  path="/config"
                  name="Configuration"
                  render={(props) => <Configuration {...props} />}
                />
                <Route
                  path="/"
                  name="Home"
                  render={(props) => (
                    <DefaultLayout
                      {...props}
                      showmessage={this.context.msgShow}
                    />
                  )}
                />
              </Switch>
            </React.Suspense>
          </GlobalState>
        </Router>
      </ErrorBoundary>
    );
  }
}

export default App;
